/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';

/**
 * Schema for updating workshop attendance.
 * @export
 * @interface WorkshopAttendanceUpdate
 */
export interface WorkshopAttendanceUpdate {
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof WorkshopAttendanceUpdate
     */
    status?: AttendanceStatus | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopAttendanceUpdate
     */
    checked_in_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceUpdate
     */
    notes?: string | null;
}



/**
 * Check if a given object implements the WorkshopAttendanceUpdate interface.
 */
export function instanceOfWorkshopAttendanceUpdate(value: object): value is WorkshopAttendanceUpdate {
    return true;
}

export function WorkshopAttendanceUpdateFromJSON(json: any): WorkshopAttendanceUpdate {
    return WorkshopAttendanceUpdateFromJSONTyped(json, false);
}

export function WorkshopAttendanceUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : AttendanceStatusFromJSON(json['status']),
        'checked_in_at': json['checked_in_at'] == null ? undefined : (new Date(json['checked_in_at'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function WorkshopAttendanceUpdateToJSON(json: any): WorkshopAttendanceUpdate {
    return WorkshopAttendanceUpdateToJSONTyped(json, false);
}

export function WorkshopAttendanceUpdateToJSONTyped(value?: WorkshopAttendanceUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': AttendanceStatusToJSON(value['status']),
        'checked_in_at': value['checked_in_at'] == null ? undefined : ((value['checked_in_at'] as any).toISOString()),
        'notes': value['notes'],
    };
}

